import navigation from '@/components/shared/navigation/navigation.vue';
import ResourceSvc from '@/services/resource.svc.js';
import AdminLayout from '@/components/shared/layout/admin-layout/admin-layout.vue';
import Sponsors from './sponsors-footer/sponsors-footer.vue';

import store from '@/services/store';
const srcSvc = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

export default {
    name: 'Layout',
    data: function () {
        return {
            baseUrl: null,
            search: "",
            firstLevel: "level-1",
            secondLevel: "level-2",
            userLoaded: false,
            userLoading: false,
            userId: 0,
            basketDetails: [],
            isShowBasket: false,
            hover: false,
            isShowSearchBtn: false
        };
    },
    components: {
        'navigation': navigation,
        'admin-layout': AdminLayout,
        'sponsors-footer': Sponsors
    },
    computed: {
        user: function () {
            return store.getters.getCurrentUser;
        },
        dashboardURL: function () {
            return '/dashboard';
            // return process.env.IsNewDashboard
            //     ? "/dashboard"
            //     : process.env.url.oldApp + '/my-account/';
        }
    },
    methods: {
        trigger() {
            setTimeout(() => { }, 1000);
            this.hover = false;
        },
        isFullPageMode() {
            if (this.user && !this.userId) {
                this.userId = this.user.id;
            }
            return window.location.pathname.startsWith('/register');
        },
        isLargeWidth: function () {
            return window.location.pathname.startsWith('/race-calendar')
                || window.location.pathname.startsWith('/race-entry')
                || window.location.pathname.startsWith('/race-odl')
                || window.location.pathname.startsWith('/clubs')
                || window.location.pathname.startsWith('/sage-result');
        },
        isLayoutVisible: function () {
            return !this.user || window.location.href.indexOf('dashboard') == -1;
        },
        getBaseUrl: function () {
            return process.env.url.newCMS;
        },
        createPathWithOldSiteUrl: function (path) {
            return process.env.url.oldApp + path;
        },
        createUrl: function (path) {
            if (!this.baseUrl) {
                this.baseUrl = process.env.url.newCMS;
            }
            return this.baseUrl + path;
        },
        createLoginUrl: function () {
            return process.env.url.oldAppLogin;
        },
        goBack: function () {
            window.history.back();
        },
        subSearch: function (event) {
            event.preventDefault();
            if (this.search == '') {
                this.isShowSearchBtn = !this.isShowSearchBtn;
            } else {
                var search = this.search.replace(/ /g, "+");
                var url = this.baseUrl + '/?s=' + search;
                location = url;
            }
        },
        bodyToggleClass: function () {
            document.body.classList.toggle("mobile-menu-active");
        },
        isInRole: function (role) {
            var that = this;
            var user = store.getters.getCurrentUser;
            if (!user || !user.id) {

                if (!this.userLoaded && this.userLoading) {
                    this.userLoading = true;
                    let getUserPromise = new Promise((resolve, reject) => {
                        srcSvc.getCurrentUserShotInfo()
                            .then(function (res) { resolve(res); })
                            .catch(function (err) { reject(err); });
                    });
                    getUserPromise.then(
                        res => {
                            that.userLoaded = true;
                            that.userLoading = false;
                            var user = res.body;
                            if (!user || user === null || !user.id) {
                                store.commit('setCurrentUser', null);
                                return user.roles.some(function (e) { return e === role; });
                            }
                            else {
                                store.commit('setCurrentUser', user);
                            }
                        },
                        error => {
                            that.userLoaded = true;
                            that.userLoading = false;
                            store.commit('setCurrentUser', null);
                            return false;
                        }
                    );
                }
                else {
                    return false;
                }
            }
            return that.user.roles.some(function (e) { return e === role; });
        },
        logout: function () {
            srcSvc.deleteAllBasketDetails()
                .then(res => {},error => {});

            this.setCookies("Authorization", null, { expires: -1 })

            var base = process.env.url.oldApp;

            window.location.href = base + "/Logout.aspx";
        },
        setCookies: function (name, value, props) {
            props = props || {}
            var exp = props.expires

            if (typeof exp == "number" && exp) {
                var d = new Date()
                d.setTime(d.getTime() + exp * 1000)
                exp = props.expires = d
            }

            if (exp && exp.toUTCString) {
                props.expires = exp.toUTCString()
            }
            value = encodeURIComponent(value)
            var updatedCookie = name + "=" + value

            for (var propName in props) {
                updatedCookie += "; " + propName
                var propValue = props[propName]
                if (propValue !== true) { updatedCookie += "=" + propValue }
            }

            document.cookie = updatedCookie;
        },
        proceedToPayment() {
            this.$router.push({ path: "/membership/billing/4" });
        },
        loadBasketData() {
            var self = this;
            window.scrollTo(0, 0);
            self.isProcessing = true;

            srcSvc.getBasketDetails().then(response => {
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        self.isShowBasket = false;
                        return;
                    }
                    else {
                        self.basketDetails = allData.outputData;
                        self.isShowBasket = true;
                        return;
                    }
                }
                self.isProcessing = false;
            });
        },
        updateBasket() {
            this.loadBasketData();
        },
    },
    mounted() {
        var self = this;
        self.isShowSearchBtn = false;
        self.loadBasketData();
    },
    created() {
        EventBus.$off('update-basket');
        EventBus.$on('update-basket', this.updateBasket)
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/layout/layout.js